import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { PATH_AFTER_LOGIN } from '../configs/config';

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const isAuthenticated = window.localStorage.getItem('auth-token');

  if (isAuthenticated) {
    return <Navigate to={PATH_AFTER_LOGIN} replace />;
  }

  return <>{children}</>;
}
